export default async function fetchLookup(lookupId, params, containerProps) {
  const { swellTheme } = containerProps;

  const value = swellTheme.resolveLookupSetting(params, lookupId);

  if (typeof value?.resolve === 'function') {
    await value.resolve();
  }

  return value || '';
}
